import React from 'react';
import Money from "./Money";

export default function PositivMoney(props){
    const {value, params, showDecimals=true, ...rest} = props
    return <Money value={Math.max(0,value).toFixed(2)} params={params} showDecimals={showDecimals} {...rest} />;
}